var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Dishwasher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3v70h58V3H9zm54 66H13V21h50v48zm0-52H13V7h50v10zm-4 8H17v40h42V25zM40 40.27a7.5 7.5 0 01-6 7.08v13.46a1.49 1.49 0 01-2.94 0V47.35a7.5 7.5 0 01-6-7.09V30h3v10h3V30h3v10h3V30h3L40 40.27zM50 48h-3v12.55A1.48 1.48 0 0145.55 62 1.56 1.56 0 0144 60.55V33a3 3 0 016 0v15zm9-34h-4v-4h4v4zm-7 0h-4v-4h4v4zm-13 0H17v-4h22v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Dishwasher.c0b9b9aa.svg";
export { SvgD1Dishwasher as ReactComponent };